// import React, { forwardRef, useEffect, useState } from "react";
// import QRWithIcon from "./qrcodeicon";
// import QRWithIconDonor from "./QRCodeDonor";
// import { getCurrentUser,getImagelink_org_logo } from "../../share/getProfile";
// import { linkPath } from "../../share/helper";

// const PrintDonorQRCode = forwardRef(({ data }, ref) => {
//   const { fullname, phone, ingerate_qrcode_id } = data;
//   const OrgProfile = getCurrentUser();
//     const [Org_ImagePath, SetOrgImagePath] = useState(
//       "https://www.pngkit.com/png/full/981-9818240_your-logo-retulp-bus-stop.png"
//     );

//   useEffect(() => {
//        const fetchLogo = async () => {
//       const logo = await getImagelink_org_logo("logo");
//       if (logo) SetOrgImagePath(linkPath + logo);
//     };
//     fetchLogo();
//   }, [OrgProfile]);
//   return (
//     <div ref={ref} style={styles.printContainer}>
      
//       {/* Paper Size: 15cm x 5cm
//          Centered Horizontally, Aligned to Top
//       */}
//       <div style={styles.page}>
        
//         {/* === Card 1 === */}
//         <div style={styles.card}>
//           <div style={styles.infoSection}>
//             <div style={styles.labelGroup}>
//               <span style={styles.label}>ឈ្មោះ៖</span>
//               <span style={styles.value}>{fullname}</span>
//             </div>
//             <div style={styles.labelGroup}>
//               <span style={styles.label}>ទូរស័ព្ទ៖</span>
//               <span style={styles.value}>{phone}</span>
//             </div>
//           </div>

//           <div style={styles.qrSection}>
//             <QRWithIconDonor
//              value={data.qrSrc}
//               iconUrl={Org_ImagePath}
          
//             />
//           </div>
//         </div>

//         {/* === Card 2 === */}
//         <div style={styles.card}>
//           <div style={styles.infoSection}>
//             <div style={styles.labelGroup}>
//               <span style={styles.label}>ឈ្មោះ៖</span>
//               <span style={styles.value}>{fullname}</span>
//             </div>
//             <div style={styles.labelGroup}>
//               <span style={styles.label}>ទូរស័ព្ទ៖</span>
//               <span style={styles.value}>{phone}</span>
//             </div>
//           </div>

//           <div style={styles.qrSection}>
//             <QRWithIconDonor
//               value={data.qrSrc}
//               iconUrl={Org_ImagePath}
             
//             />
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// });

// const styles = {
//   // Center content horizontally, start at top vertically
//   printContainer: {
//     width: "100%",
//     height: "100%", 
//     display: "flex",
//     justifyContent: "center", 
//     alignItems: "flex-start", 
    
//   },
  
//   // The actual sticker area (15cm width x 5cm height)
//   page: {
//     width: "15cm",
//     height: "5cm",
//     display: "flex",
//     flexDirection: "row",
//     gap: "10px", 
//     boxSizing: "border-box",
//   },

//   card: {
//     flex: 1, 
//     marginTop:10,
//     padding: "1px",
//     display: "flex",
//     flexDirection: "row", // Ensure side-by-side
//     justifyContent: "space-between",
 
 
//     overflow: "hidden", 
//   },

//   // Text Area (Left Side)
//   infoSection: {
//     paddingTop:20,
 
//     display: "flex",
//     flexDirection: "column",
 
//     flex: 1, 
//     paddingLeft: "5px",
//     gap: "8px", // Space between Name and Phone
//   },
 
//   labelGroup: {
//     display: "flex",
//     flexDirection: "column",
//     fontSize: "12px",
//     lineHeight: "1.3",
//   },
  
//   label: {
//     fontWeight: "bold",
//     color: "#555", // Slightly grey for label contrast
//     marginBottom: "2px",
//   },
  
//   value: {
//     fontWeight: "bold",
//     fontSize: "13px",
//     color: "#000",
//     wordBreak: "break-word", 
//   },

//   // QR Area (Right Side) - Fixed Large Size
//   qrSection: {
    
//    width: "150px",   
//     height: "150px",  
//     display: "flex",
    
 
//     flexShrink: 0, // Prevents QR from getting squished
//   },
// };

// export default PrintDonorQRCode;




import React, { forwardRef, useEffect, useState } from "react";
import QRWithIcon from "./qrcodeicon";
import QRWithIconDonor from "./QRCodeDonor";
import { getCurrentUser,getImagelink_org_logo } from "../../share/getProfile";
import { linkPath } from "../../share/helper";

const PrintDonorQRCode = forwardRef(({ data = [] }, ref) => {
  const OrgProfile = getCurrentUser();

  const [Org_ImagePath, SetOrgImagePath] = useState(
    "https://www.pngkit.com/png/full/981-9818240_your-logo-retulp-bus-stop.png"
  );

  useEffect(() => {
    const fetchLogo = async () => {
      const logo = await getImagelink_org_logo("logo");
      if (logo) SetOrgImagePath(linkPath + logo);
    };
    fetchLogo();
  }, [OrgProfile]);

  return (
    <div ref={ref} style={styles.printContainer}>
      {data.map((item, index) => (
        <div key={index} style={styles.row}>
          
          {/* === Card 1 === */}
          <div style={styles.card}>
   <div
    style={{
      position: "absolute",
      inset: 0,
      backgroundImage: "url('/images/blood1.jpg')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center",
      opacity: 0.15,           // watermark
      zIndex: 0,
    }}
  />
   <div style={{ position: "relative", zIndex: 1, display: "flex", width: "100%" }}>

    <div style={styles.infoSection}>
              <div style={styles.labelGroup}>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '40px' }}>
  <div>
    <span style={styles.label}>ឈ្មោះ៖</span><br />
    <span style={{ fontWeight: 'bold', color: 'blue' }}>
      {item.fullname}
    </span>
  </div>

  <div>
    <span style={styles.label}>ភេទ៖</span><br />
    <span style={{ fontWeight: 'bold', color: 'blue' }}>
      {item.gender}
    </span>
  </div>
</div>

              </div>
              <div style={styles.labelGroup}>
                <span style={styles.label}>ទូរស័ព្ទ៖</span><br/>
                <span style={ {fontWeight:'bold',color:'blue'}}>{item.phone}</span>
              </div>
            </div>

            <div style={styles.qrSection}>
              <QRWithIconDonor
                
                value={item.qrSrc}
                iconUrl={Org_ImagePath}
              />
            </div>
   </div>
 
        
          </div>

          {/* === Card 2 (duplicate) === */}
      
   <div style={styles.card}>
   <div
    style={{
      position: "absolute",
      inset: 0,
      backgroundImage: "url('/images/bloodlover.png')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center",
      opacity: 0.15,           // watermark
      zIndex: 0,
    }}
  />
   <div style={{ position: "relative", zIndex: 1, display: "flex", width: "100%" }}>

    <div style={styles.infoSection}>
              <div style={styles.labelGroup}>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '40px' }}>
  <div>
    <span style={styles.label}>ឈ្មោះ៖</span><br />
    <span style={{ fontWeight: 'bold', color: 'blue' }}>
      {item.fullname}
    </span>
  </div>

  <div>
    <span style={styles.label}>ភេទ៖</span><br />
    <span style={{ fontWeight: 'bold', color: 'blue' }}>
      {item.gender}
    </span>
  </div>
</div>

              </div>
              <div style={styles.labelGroup}>
                <span style={styles.label}>ទូរស័ព្ទ៖</span><br/>
                <span style={ {fontWeight:'bold',color:'blue'}}>{item.phone}</span>
              </div>
            </div>

            <div style={styles.qrSection}>
              <QRWithIconDonor
                
                value={item.qrSrc}
                iconUrl={Org_ImagePath}
              />
            </div>
   </div>
 
        
          </div>

        </div>
      ))}
    </div>
  );
});

const styles = {
  printContainer: {

    width: "100%",
    display: "flex",
    flexDirection: "column", // vertical rows
        alignItems: "center",
    gap: "6px",
  },

  // 1 row = 1 array item
  row: {
    paddingTop:10,
    marginLeft:80,
    width: "16cm",
    height: "3.5cm",
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    pageBreakInside: "avoid",
  },

card: {
  flex: 1,
  height: "100%",        // ⭐ REQUIRED
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  overflow: "hidden",
  position: "relative",
  borderRadius: "6px",
}
,

  infoSection: {
    paddingTop: 20,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    paddingLeft: "5px",
    gap: "4px",
  
  },

  labelGroup: {
    fontSize: "11px",
  },

  qrSection: {
    width: "150px",
    height: "150px",
    flexShrink: 0,
  },
   
};


export default PrintDonorQRCode;